import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Paper, 
  Typography, 
  Tabs, 
  Tab,
  Breadcrumbs
} from '@mui/material';
import { Link } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import SecurityIcon from '@mui/icons-material/Security';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BusinessIcon from '@mui/icons-material/Business';
import FieldCategoryManagement from './components/FieldCategoryManagement';

// TabPanel component to handle tab content display
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-config-tabpanel-${index}`}
      aria-labelledby={`admin-config-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

/**
 * Main configuration screen for admin settings
 * Features a tabbed interface with sections for:
 * - Field Categories
 * - Security Settings (future)
 * - Workflow Settings (future)
 * - Organization Settings (future)
 */
const ConfigurationMain = () => {
  // State for active tab
  const [activeTab, setActiveTab] = useState(0);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg">
      {/* Header with breadcrumbs */}
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
            Admin
          </Link>
          <Typography color="text.primary">Configuration</Typography>
        </Breadcrumbs>
        
        <Typography variant="h4" component="h1">
          System Configuration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage system-wide configuration settings
        </Typography>
      </Box>

      {/* Tabbed interface */}
      <Paper elevation={2} sx={{ mb: 4 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="admin configuration tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab 
            icon={<CategoryIcon />} 
            label="Field Categories" 
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab 
            icon={<SecurityIcon />} 
            label="Security Settings" 
            iconPosition="start"
            disabled
            sx={{ minHeight: 64 }}
          />
          <Tab 
            icon={<AccountTreeIcon />} 
            label="Workflow Settings" 
            iconPosition="start"
            disabled
            sx={{ minHeight: 64 }}
          />
          <Tab 
            icon={<BusinessIcon />} 
            label="Organization Settings" 
            iconPosition="start"
            disabled
            sx={{ minHeight: 64 }}
          />
        </Tabs>

        {/* Field Categories Tab */}
        <TabPanel value={activeTab} index={0}>
          <FieldCategoryManagement />
        </TabPanel>
        
        {/* Security Settings Tab (future) */}
        <TabPanel value={activeTab} index={1}>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Security Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </Box>
        </TabPanel>
        
        {/* Workflow Settings Tab (future) */}
        <TabPanel value={activeTab} index={2}>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Workflow Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </Box>
        </TabPanel>
        
        {/* Organization Settings Tab (future) */}
        <TabPanel value={activeTab} index={3}>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Organization Settings
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Coming soon
            </Typography>
          </Box>
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default ConfigurationMain;
